import { render, staticRenderFns } from "./PayTarBar.vue?vue&type=template&id=b1a556b4&scoped=true"
import script from "./PayTarBar.vue?vue&type=script&lang=js"
export * from "./PayTarBar.vue?vue&type=script&lang=js"
import style0 from "./PayTarBar.vue?vue&type=style&index=0&id=b1a556b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a556b4",
  null
  
)

export default component.exports